import { render } from "./ReserveInfoDetail_spPay.vue?vue&type=template&id=42afcfda&scoped=true"
import script from "./ReserveInfoDetail_spPay.vue?vue&type=script&lang=js"
export * from "./ReserveInfoDetail_spPay.vue?vue&type=script&lang=js"

import "./ReserveInfoDetail_spPay.vue?vue&type=style&index=0&id=42afcfda&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42afcfda"]])

export default __exports__